import { Component, OnInit } from '@angular/core';

declare const CookieConsent: any;

@Component({
  selector: 'lfwms-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  versionInfo: string = '';

  ngOnInit(): void {
    fetch('assets/version.json')
      .then(res => res.json())
      .then((v: { version: string; buildTime: string }) => {
        const d = new Date(v.buildTime);
        const date = d.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
        const time = d.toLocaleTimeString('en-GB', { hour12: false });
        this.versionInfo = `v${v.version} · Built: ${date}, ${time}`;
      })
      .catch(err => console.error('Version info not found:', err));
  }

  openCookiePreferences(): void {
    if (
      (window as any).CookieInformationScriptLoaded &&
      CookieConsent
    ) {
      CookieConsent.renew();
    }
  }
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/footer/footer.component.ts